import { CommonModule, Location } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, HostListener, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobModel } from 'src/app/services/jobModel';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

@Component({
  selector: 'app-job-portfolio',
  templateUrl: './job-portfolio.component.html',
  styleUrls: ['./job-portfolio.component.scss'],
  standalone: true,
  inputs : ['jobData' , "pageName" , "jobPortfolio", "designVersion"],
  imports: [
CommonModule,
    NG_ICON_DIRECTIVES,
  ]
})
export class JobPortfolioComponent implements OnInit , OnChanges , AfterViewInit{
  queryParams: any;
  jobPortfolio : jobModuleConfig;
  jobData : JobModel;
  leftElements: Array<String> = ["job-details","candidate-applied","job-applicants", "talent-pool", "resume-requests", "suggested-candidates"]
  rightElements: Array<String> = ["candidates-invited", "jobs-viewed", "jobs-liked", "jobs-activity"]
  constructor(private util:UtilService,private route: Router,private _location: Location, private activateRoute: ActivatedRoute,
    private searchData : SearchData) {
    this.userId = localStorage.getItem('userId');
    this.userType=localStorage.getItem('userType')
    this.searchData.setHighlighter('newjobs');
  }

  ngAfterViewInit(): void {
    // Check overflow state after view initialization
    setTimeout(() => {
      this.checkOverflow();
    }, 300);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.jobData && changes.jobData.currentValue){
      this.jobData =  changes.jobData.currentValue;
    }
    if(this.leftElements.includes(this.pageName)) {
      this.scrollLeft()
    }else if(this.rightElements.includes(this.pageName)) {
      this.scrollRight()
    }

    // Recheck overflow when data changes
    setTimeout(() => {
      this.checkOverflow();
    }, 100);
  }

  pageName:any;
  designVersion: string = 'v2';
  userId: any;
  userType:any

  get showSubContractButton(): boolean {
    const myBusinessId = localStorage.getItem('myBusinessId');
    if (!this.jobData?.tierPayRates?.length || !myBusinessId) return false;
    return this.jobData.tierPayRates.some(
      (tier: any) => tier.supplierBusinessId === myBusinessId && tier.subContracted === true
    );
  }
  ngOnInit() {
    window.scroll(0,0)

  }

  // Listen for window resize events to update chevron visibility
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkOverflow();
  }

  showChevron: boolean = false;
  showChevron1: boolean = false;
  hasOverflow: boolean = false;

  // Check if the menu container has overflow
  checkOverflow() {
    const scrollContainer = document.getElementById('scrollContainer1');
    if (scrollContainer) {
      // Check if content width exceeds container width
      this.hasOverflow = scrollContainer.scrollWidth > scrollContainer.clientWidth;
    }
  }

  // Smooth 400px hop per click — same feel as admin-hor-menu's strip.
  scrollLeft() {
    const scrollContainer = document.getElementById('scrollContainer1');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: -400, behavior: 'smooth' });
    }
  }

  scrollRight() {
    const scrollContainer = document.getElementById('scrollContainer1');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: 400, behavior: 'smooth' });
    }
  }

  onMouseEnter() {
    // Only show chevron if there's overflow
    if (this.hasOverflow) {
      this.showChevron = true;
    }
  }

  onMouseLeave() {
    this.showChevron = false;
  }

  onMouseEnter1() {
    // Only show chevron if there's overflow
    if (this.hasOverflow) {
      this.showChevron1 = true;
    }
  }

  onMouseLeave1() {
    this.showChevron1 = false;
  }




  // @ViewChild("widgetsticky", { static: false }) menuElement: ElementRef;
  // widgetstick: boolean = false
  // @HostListener("window:scroll")
  // handleScroll() {
  //   const windowScroll = window.pageYOffset || window.scrollY;
  //   if (windowScroll >= 20) {
  //     this.widgetstick = true;
  //   } else {
  //     this.widgetstick = false;
  //   }
  // }

  BackBreadCream(){
    this._location.back();
  }
  LandingPage(){
    this.route.navigate(["landingPage"]);
  }

  filterDatas={};
  exchangeparenttochild(){

  }

  onChange(value){

    this.pageName = value;
    this.jobPortfolio.jobDetails.apply(this.jobPortfolio.source,[value]);
    let data:any = {};
    data.filter = false;
    data.pageName=this.pageName;
    this.changePath();
    this.resetfilter(value);
    this.scrollSubTabToTop();

  }

  private scrollSubTabToTop(): void {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.querySelectorAll<HTMLElement>('.jc-v3-entity-details-body').forEach(el => {
        el.scrollTo({ top: 0, behavior: 'smooth' });
      });
    } catch {
      window.scrollTo(0, 0);
    }
  }

  @Output() resetfilters = new EventEmitter<any>();
  resetfilter(value){
    let data:any = {};
    data.pageName=value;
    this.resetfilters.emit(data);
  }
  @Output() removeCandidate = new EventEmitter<any>();
  changePath(){
    const url =  new URL(window.location.href);
    let queryParams = new URLSearchParams(url.hash.split('?')[1]);
    if (queryParams.has('candidateId')) {
      queryParams.delete('candidateId');
      const newHash = `${url.hash.split('?')[0]}?${queryParams.toString()}`;
      const newUrl = `${url.origin + url.pathname + newHash}`;
      window.history.pushState({}, '', newUrl);

         // selectedItem.parentType = "CANDIDATE_INVITATION";
         this.removeCandidate.emit('clear');
     }

  }

}
